import type { ImageDataLike } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';


function useLogoImageQuery(): ImageDataLike | null {
  const data = useStaticQuery(graphql`
    query LogoImage {
      file(sourceInstanceName: { eq: "images" }, relativePath: { eq: "logo.png" }) {
        childImageSharp {
          gatsbyImageData(height: 60)
        }
      }
    }
  `);

  return data.file;
}

export default useLogoImageQuery;
